import React, { useState, useRef, useEffect } from "react";

// CustomCheckbox Component - Separate and Fixed
interface CustomCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  checkboxColor?: string;
  fillColor?: string;
  indeterminate?: boolean;
}

const CustomCheckbox = React.forwardRef<HTMLInputElement, CustomCheckboxProps>(
  (
    {
      checked,
      onChange,
      label,
      checkboxColor = "#A88934",
      fillColor = "#FFF7E6",
      indeterminate = false,
    },
    ref
  ) => {
    const CHECKBOX_SIZE = "18px";
    const CHECKMARK_THICKNESS = "2px";

    const styles = {
      container: {
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        userSelect: "none",
        // backgroundColor: "red",
      } as React.CSSProperties,

      hiddenCheckbox: {
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: 0,
      } as React.CSSProperties,

      styledCheckbox: {
        width: CHECKBOX_SIZE,
        height: CHECKBOX_SIZE,
        borderRadius: "4px",
        border: `2px solid ${checkboxColor}`,
        backgroundColor: checked || indeterminate ? fillColor : "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 0.2s ease-in-out",
        marginRight: label ? "8px" : "0",
        flexShrink: 0,
      } as React.CSSProperties,

      checkmark: {
        width: "35%",
        height: "70%",
        border: `solid ${checkboxColor}`,
        borderWidth: `0 ${CHECKMARK_THICKNESS} ${CHECKMARK_THICKNESS} 0`,
        transform: "rotate(45deg)",
        opacity: checked ? 1 : 0,
        transition: "opacity 0.2s ease-in-out",
        marginBottom: "4px",
      } as React.CSSProperties,

      labelStyle: {
        fontSize: "14px",
        color: "#333",
      } as React.CSSProperties,

      indeterminateMark: {
        width: "60%",
        height: CHECKMARK_THICKNESS,
        backgroundColor: checkboxColor,
        borderRadius: "1px",
        opacity: 1,
      } as React.CSSProperties,
    };

    // FIXED: Removed e.stopPropagation() to allow proper event bubbling
    const handleToggle = (e: React.MouseEvent) => {
      e.preventDefault(); 
    
    // 🔑 EXISTING: Stop the click from bubbling out of the <label>
    e.stopPropagation();
      onChange(!checked);
    };

    const renderIndicator = () => {
      if (indeterminate) {
        return <div style={styles.indeterminateMark} />;
      }
      if (checked) {
        return <div style={styles.checkmark} />;
      }
      return <div></div>;
    };

    return (
      <label style={styles.container} onClick={handleToggle}>
        <input
          ref={ref}
          type="checkbox"
          checked={checked}
          onChange={() => {}}
          style={styles.hiddenCheckbox}
        />
        <div style={styles.styledCheckbox}>{renderIndicator()}</div>
        {label && <span style={styles.labelStyle}>{label}</span>}
      </label>
    );
  }
);

export default CustomCheckbox;
